import {
  VariantAnalyticsInputSchema,
  VariantAnalyticsOutputSchema,
} from "@redotech/redo-analytics-common/returns-claims/variant-analytics";
import * as z from "zod";

export const getReturnAnalyticsByVariant = {
  name: "getReturnAnalyticsByVariant" as const,
  input: VariantAnalyticsInputSchema,
  output: VariantAnalyticsOutputSchema,
};

export type ReturnAnalyticsByVariant = z.infer<
  typeof getReturnAnalyticsByVariant.output
>;
